import { GETShopWholesalersResponse, IOnboardingOrderAccount, IOrderAccount, IShopWholesaler, UUIDResponse } from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import * as types from './types'

export interface GetShopWholesalersSuccess {
  type: typeof types.GET_WHOLESALERS_SUCCESS
  payload: {
    data: GETShopWholesalersResponse
  }
}

export const getWholesalers = () =>
  AsyncAction<GETShopWholesalersResponse>({
    type: [types.GET_WHOLESALERS, types.GET_WHOLESALERS_SUCCESS, types.GET_WHOLESALERS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/wholesaler/shop'
      }
    }
  })

export interface SetWholesaler {
  type: typeof types.SET_WHOLESALER
  payload: IShopWholesaler
}

export const setWholesaler = (wholesaler: IShopWholesaler | null) => ({
  type: types.SET_WHOLESALER,
  payload: wholesaler
})

export const storeWholesalerCredentials = (values: Pick<IOrderAccount, 'Credentials' | 'WholesalerUUID'> & { AccountUUID?: string }) =>
  AsyncAction<UUIDResponse>({
    type: [types.STORE_WHOLESALER, types.STORE_WHOLESALER_SUCCESS, types.STORE_WHOLESALER_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/wholesaler/order-account',
        data: values
      }
    }
  })

export const storeOnboardingWholesalerCredentials = (
  values: Pick<IOnboardingOrderAccount, 'Credentials' | 'TicketUUID'> & { ShopID?: string }
) =>
  AsyncAction<UUIDResponse>({
    type: [types.STORE_WHOLESALER, types.STORE_WHOLESALER_SUCCESS, types.STORE_WHOLESALER_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/wholesaler/onboarding/order-account',
        data: values
      }
    }
  })

export const getOrderAccount = (uuid: any) => ({
  type: [types.GET_ORDER_ACCOUNT, types.GET_ORDER_ACCOUNT_SUCCESS, types.GET_ORDER_ACCOUNT_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/wholesaler/order-account/${uuid}`
    }
  }
})

export const deleteOrderAccount = (uuid: any, dryRun: boolean) => ({
  type: [types.DELETE_ORDER_ACCOUNT, types.DELETE_ORDER_ACCOUNT_SUCCESS, types.DELETE_ORDER_ACCOUNT_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'DELETE',
      url: `/modules/wholesaler/order-account/${uuid}`,
      params: {
        DryRun: dryRun
      }
    }
  }
})

export const updateWholesalerCredentials = (uuid: string, values: any) => ({
  type: [types.UPDATE_WHOLESALER, types.UPDATE_WHOLESALER_SUCCESS, types.UPDATE_WHOLESALER_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/wholesaler/order-account/${uuid}`,
      data: values
    }
  }
})

export const oauthCheck = (application: string, username: string, returnUrl: string) => ({
  type: [types.OAUTH_CHECK, types.OAUTH_CHECK_SUCCESS, types.OAUTH_CHECK_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: '/modules/oauth/token',
      params: {
        application,
        username,
        RedirectURL: returnUrl
      }
    }
  }
})

export const oauthRevoke = (application: string, username: string, administration: string, adminUUID: string) => ({
  type: [types.OAUTH_REVOKE, types.OAUTH_REVOKE_SUCCESS, types.OAUTH_REVOKE_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'DELETE',
      url: '/modules/oauth/token',
      params: {
        application,
        username,
        administration,
        adminUUID
      }
    }
  }
})
